import { PaymentStatusEnum } from "../enums/PaymentStatusEnum";
import HttpClient from "../HttpClient";
import Op from "../interfaces/SequalizeFilters/SequalizeTypes";
import ConstructSequelizeFilters from "../utils/ConstructSequelizeFilters";

export class MultiDayChefitService {

  paymentFilter(filters: any) {
    if(!filters?.paymentStatus) {
      return {};
    }
    if(filters?.paymentStatus === PaymentStatusEnum.NOT_PAID){
      return {
          paymentStatus: {[Op.eq.toString()]: PaymentStatusEnum.NOT_PAID },
          hasOptedPayAfterService: false,
      }
    } else if(filters?.paymentStatus === PaymentStatusEnum.PAID){
      return {
        [Op.or.toString()]: [
            { paymentStatus: {[Op.eq.toString()]: PaymentStatusEnum.PAID }}
        ]
      }
    } else {
      return {
        paymentStatus:  {[Op.eq]: filters?.paymentStatus }
      }
    }
  }

    async getAllMultiDayChefit(
        limit: number,
        offset: number,
        filters: any,
        sort: any,
      ) {
        
        let filter = ConstructSequelizeFilters(filters, ['customerName', 'customerPhoneNumber', 'cookName', 'cookPhoneNumber', 'sector'], ['id', 'cookId', 'status', 'date', 'time', 'cityId', 'areaId', 'cancelledBy', 'createdBy', 'createdByType', 'comboOrderId']);
        let paymentFilters = this.paymentFilter(filters);
        filters = {
          ...filter,
          ...paymentFilters
        }
        let data = await HttpClient.get("/centaurus/multi-day-chefit", {
          params: {
            limit,
            offset,
            filters,
            sort,
          },
        });
        return {
          data: data?.data?.data,
          total: data?.data?.count,
        };
      }
      async getOneMultiDayChefit(id: number) {
        let data = await HttpClient.get(`/centaurus/multi-day-chefit/${id}`);
        return data
      }

      async calculateRefundAmount(multiChefitId : number){
        let data = await HttpClient.get(`/centaurus/multi-day-chefit/${multiChefitId}/calculate-refund-amount`);
        return data.data 
      }
      async cancelMultiDayChefit(multiChefitId: number, payload: any){
        let data = await HttpClient.delete(`/centaurus/multi-day-chefit/${multiChefitId}`,{data: payload});
        return data.data
      }
      async refundMultiDayChefit(multiChefitId: number){
        let data = await HttpClient.post(`/centaurus/multi-day-chefit/${multiChefitId}/refund-multi-chefit`);
        return data.data
      }

      async assignCookToMultiDayChefit(multiChefitId: number, cookId: number){
        let data = await HttpClient.post(`/centaurus/multi-day-chefit/${multiChefitId}/assign-cook`,{cookId});
        return data.data
      }

      async createMultiDayChefit(houseId: number, payload: any){
        let data = await HttpClient.post(`/centaurus/multi-day-chefit/houses/${houseId}`, payload);
        return data.data
      }

      async checKCookAvailabilty(houseId: number, payload: any){
        let data = await HttpClient.post(`/centaurus/multi-day-chefit/houses/${houseId}/check-cook-availability`, payload);
        return data.data
      }

      async autoAllocate(multiChefitId: number){
        let data = await HttpClient.patch(`/centaurus/multi-day-chefit/${multiChefitId}/auto-allocate`);
        return data.data
      }
}